var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94736 1.89382C7.09587 1.89382 8.0381 2.83605 8.0381 3.98456V6.07529H3.85663V3.98456C3.85663 2.83605 4.79885 1.89382 5.94736 1.89382ZM9.43192 6.07529V3.98456C9.43192 2.06666 7.86527 0.5 5.94736 0.5C4.02946 0.5 2.46281 2.06666 2.46281 3.98456V6.07529H1.76589C1.39623 6.07529 1.0417 6.22214 0.780312 6.48354C0.518919 6.74493 0.37207 7.09945 0.37207 7.46912V13.0444C0.37207 13.4141 0.518919 13.7686 0.780312 14.03C1.0417 14.2914 1.39623 14.4382 1.76589 14.4382H10.1288C10.4985 14.4382 10.853 14.2914 11.1144 14.03C11.3758 13.7686 11.5227 13.4141 11.5227 13.0444V7.46912C11.5227 7.09945 11.3758 6.74493 11.1144 6.48354C10.853 6.22214 10.4985 6.07529 10.1288 6.07529H9.43192ZM1.76589 7.46912H10.1288V13.0444H1.76589V7.46912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon _lock_.607ee69d3e2c718595c58932d3de456d.svg";
export { ForwardRef as ReactComponent };